var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function Chart1IconInner(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21 2H17C16.4477 2 16 2.44772 16 3V20H15V8C15 7.44772 14.5523 7 14 7H10C9.44771 7 9 7.44772 9 8V20H8V15C8 14.4477 7.55228 14 7 14H3C2.44772 14 2 14.4477 2 15V20H1.5C0.947715 20 0.5 20.4477 0.5 21C0.5 21.5523 0.947715 22 1.5 22H3H7H10H14H17H21H22.5C23.0523 22 23.5 21.5523 23.5 21C23.5 20.4477 23.0523 20 22.5 20H22V3C22 2.44772 21.5523 2 21 2ZM11 20H13V9H11V20ZM20 20H18V4H20V20ZM4 20H6V16H4V20Z", fill: "" })));
}
export var Chart1Icon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: Chart1IconInner }, props))); };
//# sourceMappingURL=Chart1Icon.js.map